import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

const planningControllerReducer = (state: RootState) => state.private.planningController;

export const wbsDataSelector = createSelector(planningControllerReducer, (planning) => planning.wbsData);

export const wbsDataTableSelector = createSelector(planningControllerReducer, (planning) => planning.wbsDataTable);
